module.exports = __webpack_public_path__ + "static/media/farFromHomeAnim.6a21b3fa.gif";